<script>
  // Render html component for render html with vue components inside
  export default {
    props: {
      html: {
        type: String,
        required: true,
      },
    },
    render(h) {
      const render = {
        components: {
          ContactButton: () =>
            import(/* webpackChunkName: "chunk-contact-button" */ './contact-button.vue'),
          SvgMcvVerified: () =>
            import(/* webpackChunkName: "chunk-svg-mcv-verified" */ './svg/mcv-verified.vue'),
          VerifiedBadgeFooter: () =>
            import(
              /* webpackChunkName: "chunk-verified-badge-footer" */ '../components/verified-badge-footer.vue'
            ),
        },
        template: '<div>' + this.html + '</div>',
      }
      return h(render)
    },
  }
</script>
